module.exports = __webpack_public_path__ + "img/a4.12171803.jpg";